module.exports = __webpack_public_path__ + "static/media/ngc.d3cab37d.svg";